import useAccessibleSubmit from "@insite/client-framework/Common/Hooks/useAccessibleSubmit";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import updateQuoteLine from "@insite/client-framework/Store/Pages/RfqQuoteDetails/Handlers/UpdateQuoteLine";
import translate from "@insite/client-framework/Translate";
import { QuoteLineModel, QuoteModel } from "@insite/client-framework/Types/ApiModels";
import ProductBrand, { ProductBrandStyles } from "@insite/content-library/Components/ProductBrand";
import ProductDescription, { ProductDescriptionStyles } from "@insite/content-library/Components/ProductDescription";
import ProductImage, { ProductImageStyles } from "@insite/content-library/Components/ProductImage";
import ProductPartNumbers, { ProductPartNumbersStyles } from "@insite/content-library/Components/ProductPartNumbers";
import ProductPrice, { ProductPriceStyles } from "@insite/content-library/Components/ProductPrice";
import SmallHeadingAndText from "@insite/content-library/Components/SmallHeadingAndText";
import RfqQuoteDetailsQuotedPricing, {
    RfqQuoteDetailsQuotedPricingStyles,
} from "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsQuotedPricing";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Select, { SelectPresentationProps } from "@insite/mobius/Select";
import TextArea, { TextAreaProps } from "@insite/mobius/TextArea";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import CartLineAccountNumber, { CartAccountNumberStyles } from "@tJohnstonCompanies/Widgets/CartLineAccountNumber";
import QuoteCostCode from "@tJohnstonCompanies/Widgets/QuoteCostCode";
import React, { ChangeEvent, useContext, useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    quote: QuoteModel;
    quoteLine: QuoteLineModel;
    extendedStyles?: RfqQuoteDetailsProposedDetailsGridItemStyles;
}

const mapDispatchToProps = {
    updateQuoteLine,
};

type Props = OwnProps & ResolveThunks<typeof mapDispatchToProps>;

export interface RfqQuoteDetailsProposedDetailsGridItemStyles {
    container?: GridContainerProps;
    productImageGridItem?: GridItemProps;
    productImage?: ProductImageStyles;
    quoteLineInfoGridItem?: GridItemProps;
    quoteLineInfoContainer?: GridContainerProps;
    infoLeftColumn?: GridItemProps;
    infoLeftColumnContainer?: GridContainerProps;
    productBrandAndDescriptionGridItem?: GridItemProps;
    productBrand?: ProductBrandStyles;
    productDescription?: ProductDescriptionStyles;
    productPartNumbers?: ProductPartNumbersStyles;
    productPrice?: ProductPriceStyles;
    quotedPricingGridItem?: GridItemProps;
    quotedPricingText?: TypographyPresentationProps;
    quotedPricingStyles?: RfqQuoteDetailsQuotedPricingStyles;
    quantityAndSubtotalGridItem?: GridItemProps;
    quantityAndSubtotalContainer?: GridContainerProps;
    quantityGridItem?: GridItemProps;
    qty?: GridItemProps;
    CartField?: GridItemProps;
    quantityTextField?: TextFieldPresentationProps;
    subtotalGridItem?: GridItemProps;
    subtotalText?: TypographyPresentationProps;
    notesAndCostCodeGridItem?: GridItemProps;
    LineNotesAndCommentGridItem?: GridItemProps;
    toggleLink?: LinkPresentationProps;
    cartLineNotesAndCommentLinkGridItem?: GridItemProps;
    cartLineNotesGridItem?: GridItemProps;
    wrapperTextarea?: InjectableCss;
    wrapperTextareaComment?: InjectableCss;
    subtotalGridItemcustom?: InjectableCss;
    notesAndCostCodesContainer?: GridContainerProps;
    notesGridItem?: GridItemProps;
    toggleNotesLink?: LinkPresentationProps;
    notesTextArea?: TextAreaProps;
    notesCommentTextArea?: InjectableCss;
    costCodeGridItem?: GridItemProps;
    costCodeLabelText?: TypographyPresentationProps;
    costCodeSelect?: SelectPresentationProps;
    costCodeText?: TypographyPresentationProps;
    CartLineAccountNumber?: CartAccountNumberStyles;
}

export const rfqQuoteDetailsProposedDetailsGridItemStyles: RfqQuoteDetailsProposedDetailsGridItemStyles = {
    container: {
        gap: 20,
        css: css`
            border-bottom: 1px solid ${getColor("common.border")};
            // padding: 0.5rem 0;
            padding: 10px 0;
            background-color: #fff;
            padding: 10px;
            margin-bottom: 10px;
            border-radius: 7px;
        `,
    },
    productImageGridItem: {
        width: [12, 12, 12, 2, 2],
        css: css`
            display: flex;
            align-items: center;
            background-color: #ccc;
            // justify-content: center;
            // padding: 0 25px;
            border-radius: 7px 0px 0px 7px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            > a {
                                // border: 5px solid black;
                                justify-content: center;
                            }
                            border-radius: 7px 7px 0px 0px;
                        `,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
    },
    quoteLineInfoGridItem: {
        width: [12, 12, 12, 10, 10],
        css: css`
            border: 1px solid #ccc;
            border-radius: 0 7px 7px 0;
        `,
    },
    quoteLineInfoContainer: {
        gap: 20,
    },
    infoLeftColumn: {
        width: [12, 12, 12, 6, 6],
    },
    infoLeftColumnContainer: {
        gap: 20,
    },
    productBrandAndDescriptionGridItem: {
        css: css`
            flex-direction: column;
        `,
        width: 12,
    },
    productPrice: {
        wrapper: {
            css: css`
                margin-top: 10px;
            `,
        },
    },
    quotedPricingGridItem: {
        width: [12, 12, 12, 4, 4],
        css: css`
            flex-direction: column;
            // border: 5px solid black;
            > table {
                > tr {
                    //background: #fff;
                    > td {
                        border: 1px solid #ccc;
                    }
                }
            }
        `,
    },
    quotedPricingText: {
        weight: "bold",
    },
    quantityAndSubtotalGridItem: {
        width: [12, 12, 12, 6, 6],
    },
    quantityAndSubtotalContainer: {
        gap: 20,
    },
    quantityGridItem: {
        width: [12, 6, 6, 12, 12],
        printWidth: 10,
        css: css`
            @media print {
                &&&& {
                    max-width: 100%;
                }
            }
        `,
    },
    CartField: {
        width: [7, 7, 7, 7, 4],
        css: css`
            padding-left: 0;
            padding: 0;
            div[class^="FormFieldStyle"] {
                span {
                    display: none;
                }
                > div[class^="FormInputWrapper"] {
                    margin-top: 0;
                    input {
                        border-radius: 0 7px 7px 0;
                        height: 33px;
                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(
                                theme,
                                [
                                    null,
                                    null,
                                    null,
                                    css`
                                        height: 28px;
                                    `,
                                    null,
                                ],
                                "max",
                            )}

                        width: 75%;
                        background: #fff;
                    }
                    /* Chrome, Safari, Edge, Opera */
                    input::-webkit-outer-spin-button,
                    input::-webkit-inner-spin-button {
                        -webkit-appearance: none;
                        margin: 0;
                    }

                    /* Firefox */
                    input[type="number"] {
                        -moz-appearance: textfield;
                    }
                }
            }
        `,
    },
    // qty: {
    //     width: [6, 6, 6, 6, 4],
    //     css: css``,
    // },
    qty: {
        width: [3, 3, 3, 2, 2],
        css: css`
            flex-direction: column;
            background: #ccc;
            padding: 5px 0px 6px 6px !important;
            border-radius: 7px 0 0 7px;
            span {
                font-weight: 700;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            null,
                            css`
                                font-size: 11px;
                                padding: 1px 0 0 0;
                            `,

                            null,
                        ],
                        "max",
                    )}
            }
        `,
    },
    subtotalGridItem: {
        width: [12, 6, 6, 4, 4],
        printWidth: 12,
        css: css`
            padding: 5px;
            @media print {
                &&&& {
                    max-width: 100%;
                }
            }
        `,

        // align: "bottom",
    },
    subtotalGridItemcustom: {
        css: css`
            width: 100%;
            padding: 5px;
            flex-basis: 100%;
            max-width: 100%;
        `,
        // align: "bottom",
    },
    subtotalText: {
        weight: 700,
    },
    notesAndCostCodeGridItem: {
        width: 12,
    },
    notesAndCostCodesContainer: {
        gap: 20,
    },
    notesGridItem: {
        width: 6,
        css: css`
            flex-direction: column;
        `,
    },
    notesTextArea: {
        css: css`
            min-width: 100%;
            max-width: 100%;
            min-height: 50px;
        `,
    },
    toggleNotesLink: {
        css: css`
            margin-bottom: 10px;
        `,
    },
    costCodeGridItem: {
        width: [12, 12, 12, 6, 6],
        css: css`
            flex-direction: column;
        `,
    },
    costCodeLabelText: {
        css: css`
            margin-bottom: 10px;
        `,
    },
    LineNotesAndCommentGridItem: {
        width: [12, 12, 12, 12, 12],
        css: css`
            padding: 0;
            span {
                font-size: 14px;
                font-weight: 600;
                background-color: #f7f7f7;
                padding: 4px;
            }
        `,
    },
    cartLineNotesAndCommentLinkGridItem: {
        width: [12, 12, 12, 12, 12],
        css: css`
            padding: 0;
            > div[class^="GridWrapper"] {
                background-color: #efefef;
                border-radius: 7px;
                > div[class^="GridOffset"] {
                    padding: 30px;
                    > div[class^="GridItemStyle"] {
                        padding: 8px !important;
                    }
                    input {
                        background: #fff;
                    }
                }
            }
        `,
    },
    cartLineNotesGridItem: {
        width: [6, 6, 6, 6, 6],
        css: css`
            padding: 0;
            button {
                margin-bottom: 0px;

                background-color: #f7f7f7;
                padding: 5px;
            }
            span {
                font-weight: 600;
            }
        `,
    },
    wrapperTextarea: {
        css: css`
            width: 100%;
        `,
    },
    wrapperTextareaComment: {
        css: css`
            width: 100%;
            > div[class^="FormFieldStyle"] {
                > div[class^="FormInputWrapper"] {
                    > textarea {
                        border: none;
                        outline: none;
                        background: #e6e6e6;
                        color: #9c9292;
                        font-size: 16px;
                        font-weight: 600;
                        &:focus {
                            outline: none;
                            border: none;
                            padding: 10px 10px;
                        }
                    }

                    > div[class^="DescriptionWrapper"] {
                        margin-top: 0;
                    }
                }
            }
        `,
    },
};

const styles = rfqQuoteDetailsProposedDetailsGridItemStyles;

const RfqQuoteDetailsProposedDetailsGridItem = ({ quote, quoteLine, updateQuoteLine }: Props) => {
    const toasterContext = useContext(ToasterContext);

    const qtyOrderedSubmitHandler = (value: string) => {
        const inputQty = Number.parseInt(value, 10);
        if (Number.isNaN(inputQty)) {
            return;
        }

        updateQuoteLine({
            quoteId: quote.id,
            quoteLineId: quoteLine.id,
            quoteLine: {
                ...quoteLine,
                qtyOrdered: inputQty,
            },
            onSuccess: () => {
                toasterContext.addToast({ body: translate("Quantity updated"), messageType: "success" });
            },
        });
    };

    const {
        value: qtyOrdered,
        changeHandler: qtyOrderedChangeHandler,
        keyDownHandler: qtyOrderedKeyDownHandler,
        blurHandler: qtyOrderedBlurHandler,
    } = useAccessibleSubmit(quoteLine.qtyOrdered!.toString(), qtyOrderedSubmitHandler);

    const [showNotes, setShowNotes] = useState(true);
    const toggleNotesClickHandler = () => {
        setShowNotes(!showNotes);
    };

    const [notes, setNotes] = useState(quoteLine.notes);

    const notesChangeHandler = (event: ChangeEvent<HTMLTextAreaElement>) => {
        setNotes(event.currentTarget.value);
    };

    const notesBlurHandler = () => {
        updateQuoteLine({
            quoteId: quote.id,
            quoteLineId: quoteLine.id,
            quoteLine: {
                ...quoteLine,
                notes,
            },
            onSuccess: () => {
                toasterContext.addToast({ body: translate("Notes updated"), messageType: "success" });
            },
        });
    };

    const [showAccountNumber, setShowAccountNumber] = useState(true);
    const toggleAccountNumberClickHandler = () => {
        setShowAccountNumber(!showAccountNumber);
    };
    const [showNotesComment, setshowNotesComment] = useState(false);
    const lineNotesCommentClickHandler = () => {
        setshowNotesComment(!showNotesComment);
    };

    const [accountValue, setAccountNumber] = useState(quoteLine.properties.accountNumber);

    const accountChangeHandler = (event: ChangeEvent<HTMLTextAreaElement>) => {
        setAccountNumber(event.currentTarget.value);
    };

    const accountBlurHandler = () => {
        updateQuoteLine({
            quoteId: quote.id,
            quoteLineId: quoteLine.id,
            quoteLine: {
                ...quoteLine,
                properties: {
                    accountNumber: accountValue,
                },
            },
            onSuccess: () => {
                toasterContext.addToast({ body: translate("Account Number Updated"), messageType: "success" });
            },
        });
    };
    const toggleNotesHeading = showNotes
        ? translate("Line Notes")
        : // : quoteLine.notes.length === 0
          // ? translate("Add Line Notes")
          translate("Line Notes");

    const toggleAccountNumberHeading = showAccountNumber
        ? translate("Account Number")
        : // : quoteLine.properties?.accountNumber === undefined
          // ? translate("Add Account Number")
          translate("Account Number");

    const toggleComment = translate("Comment");
    useEffect(() => {
        if (quoteLine.properties.accountNumber || quoteLine.notes) {
            const showNotesComment = true;
            setshowNotesComment(showNotesComment);
        }
    }, [quoteLine.properties.accountNumber || quoteLine.notes]);
    return (
        <GridContainer
            {...styles.container}
            data-test-selector={`tst_quoteLine_${quoteLine.productId}_${quoteLine.unitOfMeasure}`}
        >
            <GridItem {...styles.productImageGridItem}>
                <ProductImage product={quoteLine} extendedStyles={styles.productImage} />
            </GridItem>
            <GridItem {...styles.quoteLineInfoGridItem}>
                <GridContainer {...styles.quoteLineInfoContainer}>
                    <GridItem {...styles.infoLeftColumn}>
                        <GridContainer {...styles.infoLeftColumnContainer}>
                            <GridItem {...styles.productBrandAndDescriptionGridItem}>
                                {quoteLine.brand && (
                                    <ProductBrand brand={quoteLine.brand} extendedStyles={styles.productBrand} />
                                )}
                                <ProductDescription product={quoteLine} extendedStyles={styles.productDescription} />
                                <ProductPartNumbers
                                    productNumber={quoteLine.erpNumber}
                                    customerProductNumber={quoteLine.customerName}
                                    manufacturerItem={quoteLine.manufacturerItem}
                                    extendedStyles={styles.productPartNumbers}
                                />
                                <ProductPrice
                                    product={quoteLine}
                                    currencySymbol={quote.currencySymbol}
                                    showLabel={false}
                                    extendedStyles={styles.productPrice}
                                />
                            </GridItem>
                        </GridContainer>
                    </GridItem>
                    <GridItem {...styles.quotedPricingGridItem}>
                        <Typography {...styles.quotedPricingText}>{translate("Quoted Pricing")}</Typography>
                        <RfqQuoteDetailsQuotedPricing
                            quote={quote}
                            quoteLine={quoteLine}
                            extendedStyles={styles.quotedPricingStyles}
                        />
                    </GridItem>
                    <GridItem {...styles.costCodeGridItem}>
                        <QuoteCostCode quote={quote} quoteLine={quoteLine} />
                    </GridItem>
                    <GridItem {...styles.quantityAndSubtotalGridItem}>
                        <GridContainer {...styles.quantityAndSubtotalContainer}>
                            <GridItem {...styles.quantityGridItem}>
                                <GridItem {...styles.qty}>
                                    <Typography as="span"> {translate("QTY")}</Typography>
                                </GridItem>
                                <GridItem {...styles.CartField}>
                                    <TextField
                                        {...styles.quantityTextField}
                                        type="number"
                                        min={0}
                                        // label={translate("QTY_quantity")}
                                        value={qtyOrdered}
                                        disabled={quoteLine.isPromotionItem || quote.isJobQuote}
                                        onChange={qtyOrderedChangeHandler}
                                        onKeyDown={qtyOrderedKeyDownHandler}
                                        onBlur={qtyOrderedBlurHandler}
                                        data-test-selector="quoteDetail_productQuantity"
                                    />
                                </GridItem>
                            </GridItem>
                            <GridItem {...styles.quantityGridItem}>
                                <GridItem
                                    {...styles.subtotalGridItemcustom}
                                    data-test-selector={`subTotal_${quoteLine.productId}_${quoteLine.unitOfMeasure}`}
                                >
                                    {quoteLine.pricing && (
                                        <>
                                            <VisuallyHidden>{translate("Subtotal")}</VisuallyHidden>
                                            <Typography {...styles.subtotalText}>
                                                {quoteLine.pricing.extendedUnitNetPriceDisplay}
                                            </Typography>
                                        </>
                                    )}
                                </GridItem>
                            </GridItem>
                            {quoteLine.properties.partNumber ? (
                                <GridItem {...styles.infoLeftColumn}>
                                    <SmallHeadingAndText
                                        heading={translate("Alternate Part Number")}
                                        text={quoteLine.properties.partNumber}
                                    />
                                </GridItem>
                            ) : null}
                        </GridContainer>
                    </GridItem>
                    {/* <GridItem {...styles.notesAndCostCodeGridItem}> */}
                    {/* <GridContainer {...styles.notesAndCostCodesContainer}> */}
                    {/* <GridItem {...styles.notesGridItem}>
                                <Link {...styles.toggleNotesLink} onClick={toggleAccountNumberClickHandler}>
                                    {toggleAccountNumberHeading}
                                </Link>
                                {showAccountNumber && (
                                    <TextArea
                                        {...styles.notesTextArea}
                                        value={accountValue}
                                        onChange={accountChangeHandler}
                                        onBlur={accountBlurHandler}
                                    />
                                )}
                            </GridItem> */}
                    {/* <GridItem {...styles.notesGridItem}>
                                    <Link {...styles.toggleNotesLink} onClick={toggleNotesClickHandler}>
                                        {toggleNotesHeading}
                                    </Link>
                                    {showNotes && (
                                        <TextArea
                                            {...styles.notesTextArea}
                                            value={notes}
                                            disabled={!quote.canModifyOrder}
                                            onChange={notesChangeHandler}
                                            onBlur={notesBlurHandler}
                                        />
                                    )}
                                </GridItem> */}
                    {/* </GridContainer> */}
                    {/* </GridItem> */}
                    {/* {quote.showLineNotes && !quoteLine.isPromotionItem && (
                        <GridItem {...styles.notesAndCostCodeGridItem}>
                            <GridContainer {...styles.notesAndCostCodesContainer}>
                                {quoteLine.properties.comment && (
                                    <GridItem {...styles.notesGridItem}>
                                        <Typography as="p">
                                            {translate("Comment : ")}
                                            {quoteLine.properties.comment}
                                        </Typography>
                                    </GridItem>
                                )}
                            </GridContainer>
                        </GridItem>
                    )} */}
                    <GridItem {...styles.LineNotesAndCommentGridItem}>
                        {/* <GridItem {...styles.LineNotesAndCommentGridItem}> */}
                        <GridItem {...styles.cartLineNotesAndCommentLinkGridItem}>
                            <Typography as="span">
                                <Link
                                    {...styles.toggleLink}
                                    onClick={lineNotesCommentClickHandler}
                                    data-test-selector="cartunit_notesShowHideButton"
                                >
                                    {translate("Account Number/Line Notes/Comment")}
                                </Link>
                            </Typography>
                        </GridItem>
                    </GridItem>
                </GridContainer>
            </GridItem>
            <GridItem {...styles.cartLineNotesAndCommentLinkGridItem}>
                {showNotesComment && (
                    <GridContainer>
                        <GridItem {...styles.cartLineNotesGridItem}>
                            <StyledWrapper {...styles.wrapperTextarea}>
                                <Link
                                    {...styles.toggleNotesLink}
                                    // onClick={toggleNotesClickHandler}
                                >
                                    {toggleNotesHeading}
                                </Link>
                                {showNotes && (
                                    <TextArea
                                        {...styles.notesTextArea}
                                        value={notes}
                                        disabled={!quote.canModifyOrder}
                                        onChange={notesChangeHandler}
                                        onBlur={notesBlurHandler}
                                    />
                                )}
                            </StyledWrapper>
                        </GridItem>
                        <GridItem {...styles.cartLineNotesGridItem}>
                            <StyledWrapper {...styles.wrapperTextarea}>
                                <Link
                                    {...styles.toggleNotesLink}
                                    // onClick={toggleAccountNumberClickHandler}
                                >
                                    {toggleAccountNumberHeading}
                                </Link>
                                {showAccountNumber && (
                                    <TextArea
                                        {...styles.notesTextArea}
                                        value={accountValue}
                                        onChange={accountChangeHandler}
                                        onBlur={accountBlurHandler}
                                    />
                                )}
                            </StyledWrapper>
                        </GridItem>
                        <GridItem {...styles.cartLineNotesGridItem}>
                            {/* {quote.showLineNotes && !quoteLine.isPromotionItem && (
                            <StyledWrapper> */}
                            <StyledWrapper {...styles.wrapperTextareaComment}>
                                {quoteLine.properties.comment && (
                                    <>
                                        <Link {...styles.toggleNotesLink}>{toggleComment}</Link>
                                        <TextArea
                                            {...styles.notesTextArea}
                                            value={quoteLine.properties.comment}
                                            hint={translate("(Read Only)")}
                                            // disabled={true}
                                            readOnly={true}
                                            // onChange={commentChangeHandler}
                                            // onBlur={commentBlurHandler}
                                        />
                                    </>
                                )}
                            </StyledWrapper>
                            {/* </StyledWrapper> */}
                            {/* )} */}
                        </GridItem>
                    </GridContainer>
                )}
            </GridItem>
        </GridContainer>
    );
};

export default connect(null, mapDispatchToProps)(RfqQuoteDetailsProposedDetailsGridItem);
